<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">

            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="姓名" v-model="params.realname"><el-button slot="append" icon="el-icon-search" @click="clickSearch"></el-button></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="手机号" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="clickSearch"></el-button></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="用户id" v-model="params.user_id"><el-button slot="append" icon="el-icon-search" @click="clickSearch"></el-button></el-input>
                </el-col>
            </el-row>

            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>

                <el-table-column prop="realname" label="姓名"></el-table-column>
                <el-table-column prop="sign" label="签名"></el-table-column>
                <el-table-column prop="sign" label="签名图像" >
                  <template slot-scope="scope">
                    <img :src="scope.row.sign" style="width:60px;height:60px;" :alt="scope.row.realname">
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="签约时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>

            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>



        </div>
        <router-view></router-view>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex'


    import { getListYga } from '../../api/third'

    export default {
        data () {
            return {
                editTitleCategroy: '',
                editCategroyVisible:false,
                CategoryList:[],
                office_area_name:[],
                office_area_id:'',
                loadingCategoryF: false,
                submitLoading:false,
                dialogVisible: false,

                current: '', // 当前店铺id
                changeStatus: true,
                activeName: 'first',
                total_count: 0,
                detailDialog: false,
                pcDialogVisible: false,
                dialogTitle: '',
                select_tags_value: '',
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    
                },
                form: {
                    distributor_id: null,
                    mobile: '',
                    address: '',
                    name: '',
                    is_valid: 'true',
                    regions_id: [],
                    regions: [],
                    shop_id: 0,
                    contact: ''
                },
                list: [],
                rowdata: {},
                downDistributorVal: false,
                distributor_id: [],

                chooseCat:[],
                checkAll:false  //全选的v-model值
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            closeDialog () {
                this.dialogVisible = false
                this.pcDialogVisible = false
            },
            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            clickSearch (e) {
                this.params.page = 1
                this.getList()
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            getList () {
                this.loading = true
                getListYga(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count
                    }
                    this.loading = false
                })
            },

            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// yga_sign.vue?41100714